
import TagFilter from '../TagFilter';
import { INSIGHT_KIND } from '../../constants';
import { getInsightReviewMeta } from '../../lib/utils';

export default function InsightList({
  insights,
  filteredInsights,
  insightSearchText,
  setInsightSearchText,
  globalSelectedTags,
  setGlobalSelectedTags,
  allAvailableTags,
  setSelectedInsightId,
  isLargeScreen,
  concepts = [],
  onSelectAsset,
  selectedInsightKind,
  setSelectedInsightKind,
  selectedInsightType,
  setSelectedInsightType,
  selectedInsightSourceNoteId,
  setSelectedInsightSourceNoteId,
  selectedInsightSourceIds,
  setSelectedInsightSourceIds,
  notes = [],
}) {
  const filters = (
    <div className="space-y-3">
      <TagFilter
        globalSelectedTags={globalSelectedTags}
        setGlobalSelectedTags={setGlobalSelectedTags}
        allAvailableTags={allAvailableTags}
        themeColor="purple"
      />
    </div>
  );

  const bottomControls = (
    <div className="shrink-0 px-4 py-3 border-t border-gray-800 bg-gray-900 shadow-2xl space-y-3">
      {filters}
      <div className="relative w-full">
        <input
          type="text"
          value={insightSearchText}
          onChange={(e) => setInsightSearchText(e.target.value)}
          placeholder="Hintを検索..."
          className="w-full bg-gray-800 border border-gray-700 text-white text-sm rounded-xl px-4 py-2 pl-10 outline-none focus:border-blue-500 transition-all placeholder-gray-500 shadow-inner h-[40px]"
        />
        <svg className="absolute left-3.5 top-3 h-4 w-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        {insightSearchText && (
          <button aria-label="検索をクリア" onClick={() => setInsightSearchText('')} className="absolute right-3 top-3 text-gray-500 hover:text-gray-300">
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );

  const activeFiltersCount = (selectedInsightKind !== 'all' ? 1 : 0) +
    (selectedInsightType !== 'all' ? 1 : 0) +
    (selectedInsightSourceNoteId ? 1 : 0) +
    (selectedInsightSourceIds.length > 0 ? 1 : 0);

  const activeFilters = activeFiltersCount > 0 && (
    <div className="flex flex-wrap gap-2 mb-4">
      {selectedInsightKind !== 'all' && (
        <span className="flex items-center gap-1 bg-purple-950/40 text-purple-300 border border-purple-800/50 px-2 py-1 rounded-lg text-[10px] font-bold">
          分類: {selectedInsightKind === INSIGHT_KIND.HINT ? 'Asset候補' : '更新提案'}
          <button onClick={() => setSelectedInsightKind('all')} className="hover:text-white transition-colors" aria-label="分類フィルタを解除">
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </span>
      )}
      {selectedInsightType !== 'all' && (
        <span className="flex items-center gap-1 bg-purple-950/40 text-purple-300 border border-purple-800/50 px-2 py-1 rounded-lg text-[10px] font-bold">
          種類: {{'hint':'Asset候補','duplicate':'重複候補','proposal':'更新提案','proposal_actionable':'更新提案','missing_link':'Missing Link','tag_merge':'タグ整理候補'}[selectedInsightType]}
          <button onClick={() => setSelectedInsightType('all')} className="hover:text-white transition-colors" aria-label="種類フィルタを解除">
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </span>
      )}
      {selectedInsightSourceNoteId && (
        <span className="flex items-center gap-1 bg-blue-950/40 text-blue-300 border border-blue-800/50 px-2 py-1 rounded-lg text-[10px] font-bold">
          Note: {notes.find(n => n.id === selectedInsightSourceNoteId)?.title || '不明なNote'}
          <button onClick={() => setSelectedInsightSourceNoteId(null)} className="hover:text-white transition-colors" aria-label="Noteフィルタを解除">
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </span>
      )}
      {selectedInsightSourceIds.length > 0 && (
        <span className="flex items-center gap-1 bg-gray-800 text-gray-300 border border-gray-700 px-2 py-1 rounded-lg text-[10px] font-bold">
          特定の項目に絞り込み中
          <button onClick={() => setSelectedInsightSourceIds([])} className="hover:text-white transition-colors" aria-label="絞り込みを解除">
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </span>
      )}
    </div>
  );

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <div className={`flex-1 overflow-y-auto overscroll-contain ${isLargeScreen ? 'px-4 py-4' : 'p-4 space-y-3'}`}>
        {activeFilters}

        {/* List of Insights */}
        <div className="space-y-3">
          <div className="rounded-xl border border-purple-900/30 bg-purple-950/20 p-3">
            <div className="flex flex-wrap gap-2">
              <span className="rounded-full border border-emerald-800/50 bg-emerald-950/40 px-2 py-0.5 text-[10px] font-bold text-emerald-200">
                Asset候補: Asset化 / 却下 / 保留
              </span>
              <span className="rounded-full border border-indigo-800/50 bg-indigo-950/40 px-2 py-0.5 text-[10px] font-bold text-indigo-200">
                更新提案: 編集 / 適用 / 却下
              </span>
            </div>
            <p className="mt-2 text-[11px] leading-relaxed text-purple-100/80">
              件数はレビュー待ちの目安です。全件を今すぐ処理する必要はなく、迷うものは保留のまま残せます。
            </p>
          </div>
          {filteredInsights.length === 0 && (
            <div className="text-sm text-gray-500 p-8 text-center border border-gray-800 rounded-xl bg-gray-900/50">
              {insights.length === 0 ? '抽出されたHintはまだありません。' : '条件に合うHintはありません。'}
            </div>
          )}
          {filteredInsights.map(insight => {
            const reviewMeta = getInsightReviewMeta(insight);
            const isProposedChange = insight.kind === INSIGHT_KIND.PROPOSED_CHANGE;

            return (
              <button key={insight.id} onClick={() => setSelectedInsightId(insight.id)} className="w-full text-left bg-gray-800/40 hover:bg-gray-800 border border-gray-700/50 hover:border-gray-600 rounded-xl p-3 transition-all shadow-sm group">
                <div className="flex justify-between items-start gap-3 mb-1.5">
                  <div className="flex flex-col flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h3 className="text-sm font-bold text-white line-clamp-1 group-hover:text-purple-300 transition-colors">
                        {isProposedChange && <span className="mr-1.5">📝</span>}
                        {insight.title}
                      </h3>
                      <span className={`shrink-0 text-[9px] font-black border px-1.5 py-0.5 rounded ${
                        isProposedChange
                          ? 'bg-indigo-950/40 text-indigo-300 border-indigo-900/50'
                          : 'bg-emerald-950/40 text-emerald-300 border-emerald-900/50'
                      }`}>
                        {reviewMeta.label}
                      </span>
                      {insight.metadata?.parseFailed && (
                        <span className="shrink-0 bg-red-950/40 text-red-400 text-[9px] font-black border border-red-900/50 px-1.5 py-0.5 rounded animate-pulse">
                          ⚠ パース失敗
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    <span className="text-[9px] font-bold uppercase tracking-widest text-gray-500 bg-gray-900/50 px-1.5 py-0.5 rounded border border-gray-700/30 whitespace-nowrap">{insight.status}</span>
                  </div>
                </div>
                <p className={`mb-2 text-[11px] ${
                  isProposedChange ? 'text-indigo-200/80' : 'text-emerald-200/80'
                }`}>
                  {reviewMeta.actionSummary}
                </p>
                <p className="text-[13px] text-gray-400 line-clamp-2 leading-relaxed">{insight.summary}</p>

                {insight.status === 'accepted' && insight.conceptId && (
                  <div className="mt-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectAsset?.(insight.conceptId);
                      }}
                      className="text-[10px] font-bold text-emerald-400 hover:text-emerald-300 transition-colors flex items-center gap-1"
                    >
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                      </svg>
                      作成済みAsset: {concepts.find(c => c.id === insight.conceptId)?.title || '(削除済み)'}
                    </button>
                  </div>
                )}

                {(insight.tags || []).length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-2">
                    {insight.tags.map(t => <span key={t} className="text-[9px] font-bold text-purple-300/80 bg-purple-950/30 border border-purple-900/30 rounded px-1.5 py-0.5">#{t}</span>)}
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {bottomControls}
    </div>
  );
}
